module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAABRUlEQVQokX2SzysEYRjHP6P3hpLioNBcHURyUE6WciO52gMnpdQWF2fJfyBXJbkqRxzcpPzY5GJTnC2ZXTNjZ+ixz5be3pmnpmee5/k+3+d9fng/1Qo50gEIYAG4dMK6fEzaiPNI6qpfswBtgEm/wzySGaAHmAX2sknirzySTdXLWSQiJonrWbFRYEr/x4Fh4M5NEtWWgAvgxYqVLHsFWLd8/UH5pOBVrw4fgHdgCzjX4ADwJEX+JbwBfUCk9gSwDQyaJAqGdI1nwDWwqwBjVe0GioAHrAIj6vdNEn6ivfrAGHCcNSRg37I/egulZ9MIa2LcAnMWQCZ+CizqnTwC0xZG8mSwgeh7R9UE2NCr3VEym+RvW60V3zhIOoEDTZRvzYFpvkSPTQYrfbVboEngSLUM1JbmS/TsU3XIVmyZd/ha7ZYBfgE4WVzXK4nZZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/PCimg/VIP.png
// module id = 4BnN
// module chunks = 41